export default __webpack_public_path__ + "static/media/4.6f49b124.gif";